import React from "react";
import { toast } from "react-toastify";
import { useTheme, Divider, Chip, Button } from "@mui/material";

import { resetPassword } from "../../helpers/firebase";

import SimpleBox from "../../components/layout/container/SimpleBox";
import EmailInput from "../../components/input/text/EmailInput";
import DefaultLink from "../../components/link/DefaultLink";
import GoogleButton from "../../components/input/button/GoogleButton";
import UserContainer from "../../components/layout/container/UserContainer";

const ForgotPassword = () => {

    const theme = useTheme();

    const [email, setEmail] = React.useState(null);
    const [errors, setErrors] = React.useState({email: null});

    const handleSubmit = () => {
        const newErrors = {email: null};
        if (email === null || email === "") { newErrors.email = "Por favor, preencha o email"; }
        setErrors(newErrors);

        if (newErrors.email !== null) { return; }

        resetPassword(email, ({ error }) => {
            if (error === null) {
                toast.success("Verifique o seu email para repor a palavra passe!", {autoClose: 8000});
            }
            else {
                toast.error("Ocorreu um erro ao repor a password. Por favor, tente novamente mais tarde ou contacte-nos.", {autoClose: 8000});
            }
        });
    }

    return (
        <UserContainer
            title="Repor Password"
            message="Por favor, insira o seu email para recuperar a password."
        >
            <SimpleBox gap={4} flexDirection="column" mt={6} alignItems="left">
                <EmailInput value={email} errorText={errors.email} onChange={(e) => { setEmail(e.target.value); setErrors({...errors, email: null}) }} />
                <Button variant="contained" color="primary" fullWidth={true} onClick={handleSubmit}>Enviar</Button>
                <SimpleBox justifyContent="space-between">
                    <DefaultLink label="Criar Conta" to="/register" fontSize="0.95rem" allCaps={true} />
                    <DefaultLink label="Entrar" to="/login" fontSize="0.95rem" allCaps={true} />
                </SimpleBox>
            </SimpleBox>
            <Divider sx={{ marginY: theme.spacing(4)}}>
                <Chip label="OU" size="small" />
            </Divider>
            <GoogleButton />
        </UserContainer>
        
    );
};

export default ForgotPassword;
